export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AUTH_CLIENT_ID || "e0f9d0b2-5925-4a60-9704-ff55d704a070",
        authority: process.env.REACT_APP_AUTH_AUTHORITY || "https://hobtalk.ciamlogin.com",
        knownAuthorities: [
            process.env.REACT_APP_AUTH_KNOWN_AUTHORITY || "hobtalk.ciamlogin.com"
        ],
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    }
};

export const loginRequest = {
    scopes: [
        "openid",
        "profile",
        "email"
    ]
};

export const apiTokenRequest = {
    scopes: [
        process.env.REACT_APP_API_SCOPE || "api://51780992-1cc5-44c2-a178-dbe6885e75af/access_as_user"
    ]
};
